import EpisodeCard from './EpisodeCard'

interface Episode {
  number: number
  title: string
  duration?: string
  thumbnailUrl?: string
}

interface ModuleSectionProps {
  moduleId: number // ID real do módulo no banco
  moduleOrder?: number // Ordem de exibição (1, 2, 3...)
  title: string
  description: string
  episodes: Episode[]
}

const ModuleSection = ({
  moduleId,
  moduleOrder,
  title,
  description,
  episodes,
}: ModuleSectionProps) => {
  const displayOrder = moduleOrder || moduleId // Usa moduleOrder se fornecido, senão usa moduleId
  const isLocked = displayOrder === 4 || displayOrder === 5

  return (
    <section id={`module-${displayOrder}`} className="py-16 border-b border-border last:border-b-0">
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
          {/* Module Info */}
          <div className="lg:col-span-4 space-y-4">
            <span className={isLocked ? 'module-badge-locked' : 'module-badge'}>
              Módulo {displayOrder}
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-foreground">{title}</h3>
            <p className="text-muted-foreground leading-relaxed">
              {description.replace(/<[^>]*>/g, '')}
            </p>
          </div>

          {/* Episodes Grid */}
          <div className="lg:col-span-8">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {episodes.map((episode) => (
                <EpisodeCard
                  key={episode.number}
                  moduleId={moduleId}
                  moduleOrder={displayOrder}
                  episodeNumber={episode.number}
                  title={episode.title}
                  duration={episode.duration}
                  thumbnailUrl={episode.thumbnailUrl}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ModuleSection
